var React = require('react');

function Conversation (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#006EAE;}\n\t.st1{fill:#46A8F6;}\n"),React.createElement("path",{"id":"Path_3625","className":"st0","d":"M126.7,75.5c1.4,0,2.8,0.1,4.2,0.2c2.5-5.9,3.9-12.2,3.9-18.7c0-30.7-29.9-55.7-66.7-55.7\n\tS1.4,26.3,1.4,57c0,16.3,8.4,31.5,23,42.1v29.5l30.6-17c7.3,1.2,14.6,1.4,21.9,0.6C80.3,91.5,101.4,75.5,126.7,75.5z","key":1}),React.createElement("path",{"id":"Path_3626","className":"st1","d":"M126.7,79c25.7,0,46.7,17.5,46.7,39c0,11.4-5.9,22.1-16.1,29.5v20.7l-21.4-11.9\n\tc-3,0.5-6.1,0.8-9.1,0.8C101,157,80,139.5,80,118S101,79,126.7,79z","key":2})]);
}

Conversation.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 175.9 170.5","style":{"enableBackground":"new 0 0 175.9 170.5"},"xmlSpace":"preserve"};

module.exports = Conversation;

Conversation.default = Conversation;
